import BigNumber from 'bignumber.js';

const host = `${window.location.protocol}//${window.location.host}`;
const url = process.env.VUE_APP_API_BASE_URL;

export function isPc() {
  const userAgentInfo = navigator.userAgent;
  const Agents = new Array([
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ]);
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export function isMobile() {
  // detect mobile
  return /Mobi/.test(navigator.userAgent);
}

export function isChrome() {
  // detect browser; NOTE: navigator.userAgent detecting microsoft edge as chrome
  return (
    /Chrome/.test(navigator.userAgent) &&
    !/Edge|Edg|EdgiOS/.test(navigator.userAgent)
  );
}

export function parseStringToJson(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return false;
  }
}

export function toZtx(balance) {
  return new BigNumber(balance).dividedBy(1_000_000).toFixed(); // or .toString()
}

export function toDecimal(balance, decimal) {
  return new BigNumber(balance).dividedBy(new BigNumber(10).pow(decimal)).toFixed(); // or .toString()
}

export function toZeta(amount, decimal) {
  return new BigNumber(amount).multipliedBy(new BigNumber(10).pow(decimal)).toFixed(0);
}

export function openTxExplorer(hash) {
  var url = "https://test-explorer.zetrix.com/tx/" + hash;
  if (isMainnetNetwork() === true) {
    url = "https://explorer.zetrix.com/tx/" + hash;
  }

  window.open(url, "_blank");
}

export function openAccountExplorer(address) {
  var url = "https://test-explorer.zetrix.com/account/" + address;
  if (isMainnetNetwork() === true) {
    url = "https://explorer.zetrix.com/account/" + address;
  }
  window.open(url, "_blank");
}

export function isMainnetNetwork() {
  if (
    host.includes("localhost") ||
    host.includes("test") ||
    host.includes("dev") ||
    url.includes("localhost") ||
    url.includes("test") ||
    url.includes("dev")
  ) {
    return false;
  } else return true;
}

export function filterDecimal(inputValue) {
  const filteredValue = inputValue.replace(/\D/g, ""); // Remove non-numeric characters
  return filteredValue / 1;
}
